<div
  class="card"
  [class.modal]="modal()"
  [class.fine]="fine() && !detail()"
  [class.critical]="!fine() && !detail()"
  [class.detail]="detail()"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
>
  <nz-card
    [nzTitle]="plant() && !plant()?.filtered ? plantheader : ''"
    [class.show-layer]="showLayer()"
  >
    @if (showLayer()) {
      <span class="layer-label detail">
        {{ i18n.parse(plant()?.layerName) }}
      </span>
    }

    <!-- All fine (no issues, has working) -->
    @if (
      hasOnlyWorkingAndNoIssues() && !detail() && plant() && !plant()?.filtered
    ) {
      <div class="nz-multiple-status-reports">
        <nz-alert
          nzType="success"
          class="nz-status-report noMarginTop"
          [class.center]="!isDesktop()"
          [nzMessage]="allfineTemplate"
        ></nz-alert>

        <ng-template #allfineTemplate>
          <i nz-icon nzType="icons:status-check" class="fillgreen"></i>
          <span class="body-bold">
            {{ i18n.langString("all_equipments_working_fine") }}
          </span>
        </ng-template>
      </div>
    }

    <!-- Render projected content when fine=false OR detail=true -->
    @if (!fine() || detail()) {
      <ng-content></ng-content>
    }
    @if (hasAnyIssues() && !detail() && plant() && !plant()?.filtered) {
      <div>
        @if ((plant()?.Working?.length ?? 0) > 0) {
          <nz-alert
            nzType="success"
            class="nz-status-report"
            [class.center]="!isDesktop()"
            [nzMessage]="otherfineTemplate"
          ></nz-alert>
        }
        <ng-template #otherfineTemplate>
          <i nz-icon nzType="icons:status-check" class="fillgreen"></i>
          @if (plant()?.Working?.length === 1) {
            <span class="body-bold">
              {{ plant()?.Working?.length }}
              {{ i18n.langString("other_equipment_working_fine") }}
            </span>
          } @else {
            <span class="body-bold">
              {{ plant()?.Working?.length }}
              {{ i18n.langString("other_equipments_working_fine") }}
            </span>
          }
        </ng-template>
      </div>
    }

    <!-- Mobile / tablet CTA -->
    @if (!detail() && !isDesktop() && plant() && !plant()?.filtered) {
      <app-nav-button
        [primary]="true"
        [asset]="plant()"
        svgIcon="icons:plant"
        (clickEvent)="onNav()"
      >
        {{ i18n.langString("see_whole_plant") }}
      </app-nav-button>
    }
  </nz-card>

  <ng-template #plantheader>
    @if (plant() && !plant()?.filtered) {
      <div class="plant-header">
        @if (!detail()) {
          <nz-avatar
            [nzSrc]="
              plant()?.['thumbnail']
                ? plant()?.['thumbnail']
                : 'assets/images/plant_default_picture.png'
            "
            [nzSize]="isMobile() || isTablet() ? 40 : 48"
            nzText="Plant"
          >
          </nz-avatar>
        }

        @if (!detail()) {
          <h1
            class="plant-title"
            [class.mobile]="isMobile()"
            [class.tablet]="isTablet()"
          >
            {{ plant()?.objectName }}
            [{{ assetsCount() }}]
          </h1>
        } @else {
          <h2 class="plant-title">
            {{ plant()?.objectName }}
            @if (!isDisabled()) {
              <span>[{{ assetsCount() }}]</span>
            }
          </h2>
        }

        @if (closeBtn()) {
          <button (click)="closeEvent.emit()" id="closeBtn">
            <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
          </button>
        }

        @if (!detail() && isDesktop()) {
          <app-nav-button
            [primary]="true"
            [asset]="plant()"
            svgIcon="icons:plant"
            (clickEvent)="onNav()"
          >
            {{ i18n.langString("see_whole_plant") }}
          </app-nav-button>
        }
      </div>

      @if (plant()?.buildingPlan) {
        <div
          class="file-notice"
          (click)="openBuildingPreview(plant()?.buildingPlan)"
        >
          <img
            nz-image
            [src]="'assets/images/building-plan.png'"
            alt="File Preview"
          />
          <span class="body-bold link-underline">
            {{ i18n.langString("view_building_plan") }}
          </span>
        </div>
      }
    }
  </ng-template>
</div>

<nz-modal
  nzClassName="viewbuilding_modal"
  [class.desktop]="isDesktop()"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
  [nzVisible]="modalOpen()"
  [nzFooter]="null"
  [nzCentered]="true"
  [nzCloseIcon]="'icons:exit'"
  (nzOnCancel)="cancelClick()"
  [nzTitle]="''"
>
  @if (modalOpen()) {
    <!-- If using ngx-extended-pdf-viewer -->
    <!-- <ngx-extended-pdf-viewer
      [src]="srclink()"
      useBrowserLocale="true"
      [minifiedJSLibraries]="false"
      backgroundColor="#ffffff"
      [showToolbar]="false"
      [height]="'60vh'"
      [mobileZoom]="'100%'"
      [pageViewMode]="'all'"
      [showBorders]="false">
    </ngx-extended-pdf-viewer> -->

    <div class="text-center">
      <button nz-button class="ant-btn ant-btn-round" (click)="openNewTab()">
        Open in new tab
        <i nz-icon [nzType]="svg_icon_top" class="svg-icon fillwhite"></i>
      </button>
    </div>
  }
</nz-modal>
